import i18next from 'i18next';

const namespace = 'document';
const config = {
  zh: {},
  en: {
    title: 'Folder',
    name: 'Name',
    creator: 'Creator',
    update_time: 'Update Time',
    file_size: 'File Size',
    directory: 'Directory',
    operation: 'Operation',
    all: 'All',
    search: 'Search',
    placeholder_search: 'Search by folder name/file name',
    no_data: 'No Folder',
    no_search_result: 'No Results Found',
    delete_confirm: 'Are you sure to delete?',
    delete_confirm_2: 'Delete this folder will delete its sub-files as well, are you sure to delete？',
    create_suc: 'Folder created successfully',
    update_suc: 'Successfully updated',
    password: 'Password',
    pwd_copied: 'Password Copied',
    copy: 'copy',
    confirm: 'Confirm',
    modify_permissions: 'Modify Permissions',
    download: 'Download',
    delete: 'Delete',
    view_pwd: 'View Password',
    alert: 'Alert',
    batch_delete: 'Batch Delete',
    upload: 'Upload',
    create_folder: 'Create Folder',
    folder_exists: '{{folderName}} already exists`',
    no_file: 'No file',
  },
};

Object.keys(config).forEach((key) => {
  i18next.addResources(key, namespace, config[key]);
});
